import { AppleMapResultsProps } from "@wt/shared/components/maps/mapkit/types";
import { Spinner } from "@wt/shared/components/spinner/spinner";
import { Map } from '@wt/shared/libs/mapkit';
import { useRef } from 'react';

const MapResultsElement = (props: AppleMapResultsProps) => {
  const mapRef = useRef<mapkit.Map | null>(null);
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const mapContainerRef = useRef<HTMLDivElement | null>(null);

  const mapLoaded = () => {
    if (loaderRef.current && mapRef.current && mapContainerRef.current) {
      setTimeout(() => {
        loaderRef.current?.classList.remove('opacity-100');
        loaderRef.current?.classList.add('opacity-0');
        mapContainerRef.current?.classList.add('opacity-100');
      }, 150);
    }
  };

  return (
    <div className="relative size-full">
      <div
        ref={loaderRef}
        className="pointer-events-none absolute inset-0 z-[999] flex flex-col items-center justify-center bg-[#230352] text-white opacity-100 backdrop-blur-md transition-all duration-300 ease-in-out"
      >
        <Spinner />
      </div>
      <div
        ref={mapContainerRef}
        className="relative z-0 size-full opacity-0 transition-all duration-300 ease-in-out"
      >
        <Map ref={mapRef} onLoad={mapLoaded}>
          {props.children}
        </Map>
      </div>
    </div>
  );
};

export default MapResultsElement;
